var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverviewIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7205_10248)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1871 18.9931H14.9475C13.7209 18.9931 12.4944 18.9931 11.2679 18.9931C10.4408 18.9931 10.0333 18.5936 10.0325 17.7808C10.0308 14.9074 10.0308 12.0336 10.0325 9.15932C10.0325 8.39186 10.433 7.99846 11.202 7.99805H18.3112C19.0823 7.99805 19.5063 8.41367 19.5068 9.17414C19.5088 10.9465 19.5105 12.7189 19.5014 14.4912C19.4947 14.6267 19.446 14.7567 19.3621 14.8637C19.0868 15.2126 18.7908 15.5455 18.4538 15.9418V15.6093C18.4538 13.7542 18.4538 11.899 18.4538 10.0437C18.4538 9.34409 18.1532 9.04781 17.446 9.04739C15.6606 9.04739 13.8752 9.04739 12.0895 9.04739C11.3906 9.04739 11.0904 9.35026 11.0904 10.0494C11.0904 12.3519 11.0904 14.6543 11.0904 16.9566C11.0904 17.6105 11.3898 17.9072 12.0555 17.9096C12.7143 17.9117 13.3738 17.9166 14.0325 17.9059C14.2166 17.9026 14.3008 17.9804 14.4056 18.1191C14.637 18.4174 14.9081 18.6849 15.1871 18.9931Z",
    fill: "#457AEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7373 14.0303C21.9464 14.0074 22.1614 14.0706 22.3496 14.2285C22.7015 14.524 22.7434 15.0244 22.4092 15.416V15.417C21.2238 16.806 20.0326 18.1904 18.8369 19.5703C18.6635 19.77 18.4591 19.8763 18.2549 19.8965C18.0509 19.9165 17.837 19.8513 17.6426 19.6895C16.8971 19.0679 16.1607 18.4333 15.4248 17.7979C15.2876 17.6795 15.2028 17.5467 15.1641 17.4053C15.1253 17.2637 15.1305 17.1061 15.1836 16.9355C15.2864 16.6054 15.5324 16.4157 15.8887 16.3711C16.1335 16.3407 16.348 16.4311 16.5449 16.5986C16.9752 16.9654 17.4059 17.3312 17.8369 17.6963C17.8923 17.7462 17.9541 17.7935 18.0215 17.8467L18.0967 17.9053L18.1592 17.833C18.7582 17.1371 19.3484 16.4522 19.9375 15.7666C20.3385 15.3001 20.7347 14.832 21.1387 14.3672C21.3154 14.1636 21.5276 14.0533 21.7373 14.0303Z",
    fill: "#457AEF",
    stroke: "white",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8208 13.1985H12.5935C12.3186 13.1985 12.0728 13.1331 11.9588 12.8545C11.8128 12.4997 12.0736 12.1527 12.5011 12.133C12.7677 12.121 13.0351 12.1305 13.3017 12.1305C14.553 12.1305 15.8042 12.1305 17.0552 12.1305C17.4648 12.1305 17.7057 12.3285 17.7099 12.6544C17.7159 12.7753 17.677 12.8942 17.6006 12.9885C17.5242 13.0828 17.4155 13.146 17.2952 13.166C17.1891 13.1866 17.0812 13.1968 16.9731 13.1965C16.2554 13.1998 15.5381 13.1985 14.8208 13.1985Z",
    fill: "#457AEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.823 10.3838C15.5735 10.3838 16.3241 10.3838 17.0748 10.3838C17.3037 10.3838 17.5043 10.4373 17.6354 10.6418C17.8261 10.9402 17.6515 11.3518 17.3037 11.4193C17.2133 11.4348 17.1217 11.4417 17.03 11.4399C15.554 11.4399 14.0778 11.4399 12.6015 11.4399C12.2396 11.4399 12.029 11.3222 11.9514 11.088C11.8304 10.7225 12.0932 10.3883 12.5223 10.3883C13.2886 10.3793 14.0556 10.3842 14.823 10.3838Z",
    fill: "#457AEF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.819 14.9051C14.0357 14.9051 13.2525 14.9076 12.4693 14.9031C12.182 14.9031 11.9888 14.7492 11.9386 14.5088C11.8885 14.2685 11.9871 14.0437 12.2007 13.9503C12.3071 13.904 12.4219 13.8797 12.5382 13.8787C14.0543 13.8738 15.5708 13.8738 17.0877 13.8787C17.4165 13.8787 17.6342 14.0273 17.6918 14.2586C17.781 14.6129 17.5446 14.901 17.1437 14.9035C16.3688 14.9089 15.5939 14.9051 14.819 14.9051Z",
    fill: "#457AEF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0395 15.5535C14.6999 15.8087 14.4437 16.0914 14.2733 16.4565C14.2443 16.5178 14.1373 16.58 14.066 16.58C13.5577 16.5907 13.0492 16.5919 12.5406 16.5837C12.1517 16.5775 11.915 16.3623 11.9262 16.0486C11.9374 15.735 12.1625 15.5548 12.5481 15.5548C13.379 15.5526 14.2094 15.5522 15.0395 15.5535Z",
    fill: "#457AEF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7205_10248",
    x: 0,
    y: 0,
    width: 31,
    height: 31,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.678431 0 0 0 0 0.772549 0 0 0 0 0.839216 0 0 0 0.54 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7205_10248"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7205_10248",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewIcon);
export default __webpack_public_path__ + "static/media/overview_icon.f6105d81d96af7b534b0debabccfa125.svg";
export { ForwardRef as ReactComponent };